<template>
  <div data-testid="yard-task-comment-form">
    <div v-if="isLoading" class="d-flex justify-center align-center h-100 px-3 py-4">
      <v-progress-linear indeterminate color="primary"></v-progress-linear>
    </div>
    <div v-else class="d-flex flex-column">
      <!-- TODO: (welington) drop quirky global styles. -->
      <!-- This padding is an override for a global style that is applied in satellite's main.scss file. -->
      <v-form style="padding: 0 !important">
        <!-- This margin is an override for a global style that is applied in satellite's main.scss file. -->
        <v-textarea
          v-bind="$attrs"
          data-testid="yard-task-comment-form-textarea"
          style="margin-top: 0 !important"
          v-model="commentContent"
          :loading="isLoading"
          append-inner-icon="mdi-send"
          density="compact"
          variant="outlined"
          color="primary"
          hide-details
          clearable
          auto-grow
          rows="1"
          row-height="32"
          @click:append-inner="handleSubmit"
          @keydown.enter.exact.prevent="handleSubmit"></v-textarea>
      </v-form>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

import { useNotify } from '@satellite/composables/useNotify';
import commentService from '@satellite/services/comment-service';

const props = defineProps<{
  relatedEntity: string;
  relatedId: string;
}>();

const emit = defineEmits(['comment']);

const { notify } = useNotify();
const { t } = useI18n();
const commentContent = ref('');
const isLoading = ref(false);

const handleSubmit = async () => {
  if (!commentContent.value?.trim() || isLoading.value) {
    return;
  }

  isLoading.value = true;

  try {
    await commentService.createComment({
      htmlContent: commentContent.value,
      relatedEntity: props.relatedEntity,
      relatedId: props.relatedId
    });

    emit('comment');
    commentContent.value = '';
  } catch (error) {
    const errorMessage =
      error?.response?.data?.message || error?.message || 'Failed to create comment';
    console.error('Failed to create comment', errorMessage, error);

    notify(t('global.timeline.failedToCreateComment'), 'error');
  } finally {
    isLoading.value = false;
  }
};
</script>
